import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { MyCarsButtons } from 'wsm-mycars-buttons';
import { MyCarsCtas } from 'wsm-mycars-ctas';
import { useFlags, usePrefs, useLabels } from 'wsm-common-data';
import { selectIsTabbedLayout } from '../../../features/layoutSlice';
import { enableModernMyCarsFlag } from '../../../global-constants';

const MyCars = ({
	vehicle: {
		uuid,
		title,
		images,
		pricing,
		accountId,
		bodyStyle,
		make,
		model,
		stockNumber,
		trim,
		type,
		vin,
		year
	}
}) => {
	const flags = useFlags();
	const { mycarsSaveLabel, mycarsSavedLabel } = usePrefs();
	const labels = useLabels();
	const isTabbedLayout = useSelector((state) => selectIsTabbedLayout(state));
	const finalPrice = useMemo(
		() =>
			pricing?.dPrice?.find((price) => price?.isFinalPrice)?.value ||
			null,
		[pricing]
	);
	const enableModernMyCars = flags[enableModernMyCarsFlag];
	const { useSimplifiedListing } = useSelector((state) => state.layout);
	const modernMyCarsLabels = [
		{
			id: 'trackPrice',
			default: labels.get('TRACK_PRICE')
		},
		{
			id: 'save',
			default: labels.get(enableModernMyCars ? 'SAVE' : mycarsSaveLabel)
		}
	];

	return (
		<>
			{enableModernMyCars ? (
				<MyCarsCtas
					uuid={uuid}
					title={title}
					price={finalPrice}
					image={images?.[0] || null}
					isInLine={!isTabbedLayout}
					labels={modernMyCarsLabels}
					accountId={accountId}
					bodyStyle={bodyStyle}
					make={make}
					model={model}
					stockNumber={stockNumber}
					trim={trim}
					type={type}
					vin={vin}
					year={year}
				/>
			) : (
				<MyCarsButtons
					key="MyCarsButtonComponent"
					uuid={uuid}
					isLink
					useSimplifiedListing={useSimplifiedListing}
					{...{
						mycarsSaveLabel,
						mycarsSavedLabel
					}}
				/>
			)}
		</>
	);
};

MyCars.propTypes = {
	vehicle: PropTypes.shape({
		images: PropTypes.arrayOf(
			PropTypes.shape({
				uri: PropTypes.string
			})
		),
		uuid: PropTypes.string,
		link: PropTypes.string,
		pricing: PropTypes.shape({
			dPrice: PropTypes.arrayOf({})
		}),
		title: PropTypes.string,
		accountId: PropTypes.string,
		bodyStyle: PropTypes.string,
		make: PropTypes.string,
		model: PropTypes.string,
		stockNumber: PropTypes.string,
		trim: PropTypes.string,
		type: PropTypes.string,
		vin: PropTypes.string,
		year: PropTypes.number
	}).isRequired
};

export default MyCars;
